import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import CutoutImage from "../../../assets/VideoEditing/images/api-video-rmbg.png";
import { ConsoleAPICardProps } from "../../../components/Home/API/Cards/Card/ConsoleAPICard";
import ConsoleAPICards from "../../../components/Home/API/Cards/ConsoleAPICards";
import ConsoleAPILayout from "../../../components/Home/API/ConsoleAPILayout";
import BriaButton from "../../../components/common/BriaButton/BriaButton";
import LinkConstants from "../../../constants/LinkConstants";

const VideoEditingAPI = () => {
	const { t } = useTranslation("translation", { keyPrefix: "videoEditing.api" });

	const openDocs = (link: string) => window.open(link, "_blank");

	const videoEditingApiCards: ConsoleAPICardProps[] = [
		{
			image: CutoutImage,
			header: t("cards.removeBg.header"),
			description: t("cards.removeBg.description"),
			buttons: (
				<BriaButton
					buttonType="textSmall"
					onClick={() => openDocs(LinkConstants.VIDEO_EDITING.REMOVE_BACKGROUND.DOCS)}
				>
					{t("cards.removeBg.primaryBtn")}
				</BriaButton>
			),
			onClick: () => openDocs(LinkConstants.VIDEO_EDITING.REMOVE_BACKGROUND.DOCS),
		},
	];

	return (
		<ConsoleAPILayout description={t("description")}>
			<ConsoleAPICards cards={videoEditingApiCards} />
		</ConsoleAPILayout>
	);
};

export default observer(VideoEditingAPI);
